import API from './API.ts'

export default {
  //
  // GET
  //
  getPositions () {
    return API.httpClient.get('positions')
  },
  getCategories () {
    return API.httpClient.get('categories')
  },
  getCategoriesAndPositions () {
    return API.httpClient.get('categories/categories-and-positions')
  },
  getBeds () {
    return API.httpClient.get('categories/beds')
  },
  getAmenities () {
    return API.httpClient.get('categories/amenities')
  },
  getAvailabilities ({ checkIn, checkOut, bookingId, occupancy, dogs }) {
    return API.httpClient.get('positions/availability', {
      params: {
        check_in: checkIn.format('YYYY-MM-DD'),
        check_out: checkOut.format('YYYY-MM-DD'),
        booking_id: bookingId,
        occupancy,
        dogs
      }
    })
  },
  getCategoryAvailabilities ({ checkIn, checkOut, bookingId, occupancy, dogs }) {
    return API.httpClient.get('categories/availability', {
      params: {
        check_in: checkIn.format('YYYY-MM-DD'),
        check_out: checkOut.format('YYYY-MM-DD'),
        booking_id: bookingId,
        occupancy,
        dogs
      }
    })
  },
  getPositionBlocks ({ positionId = null }) {
    return API.httpClient.get('positions/blocks', {
      params: {
        position_id: positionId
      }
    })
  },
  getPositionBlock ({ positionBlockId }) {
    return API.httpClient.get('positions/blocks/show', {
      params: {
        position_block_id: positionBlockId
      }
    })
  },
  getPositionCalendarEvents (positionId) {
    return API.httpClient.get('calendar/position-events', {
      params: {
        position_id: positionId
      }
    })
  },
  getElectricRecords ({ positionId, limitId, count }) {
    return API.httpClient.get('positions/electric-records', {
      params: {
        position_id: positionId,
        limit_id: limitId,
        count
      }
    })
  },
  getCalendarEvents () {
    return API.httpClient.get('calendar')
  },
  getCalendarPaymentStatuses () {
    return API.httpClient.get('calendar/payment-statuses')
  },

  //
  // POST
  //
  updateRemarks ({ positionId, remarks }) {
    return API.httpClient.post(`positions/${positionId}/remarks`, {
      remarks,
      timestamp: Date.now()
    })
  },
  reorderPositions ({ positionIds }) {
    return API.httpClient.post('positions/reorder', {
      position_ids: positionIds
    })
  },
  savePositionBlocks ({ positionBlockId, positionIds, closingDate, openingDate, reason }) {
    return API.httpClient.post('positions/save-position-blocks', {
      position_block_id: positionBlockId,
      position_ids: positionIds,
      closing_date: closingDate.format('YYYY-MM-DD'),
      opening_date: openingDate.format('YYYY-MM-DD'),
      reason
    })
  },
  deletePositionBlock ({ positionBlock }) {
    return API.httpClient.post('positions/unblock', {
      position_block_id: positionBlock.id
    })
  },
  saveElectricRecord ({ positionId, value }) {
    return API.httpClient.post('positions/create-electric-record', {
      position_id: positionId,
      value
    })
  },
  updateElectricRecord ({ electricRecordId, value, recordedAt }) {
    return API.httpClient.post('positions/update-electric-record', {
      electric_record_id: electricRecordId,
      value,
      recorded_at: recordedAt
    })
  },
  deleteElectricRecord ({ electricRecordId }) {
    return API.httpClient.post('positions/delete-electric-record', {
      electric_record_id: electricRecordId
    })
  },
  saveElectricityCharge ({ charge }) {
    return API.httpClient.post('positions/save-electricity-charge', {
      charge
    })
  }
}
